import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ResponsdoctorsMedicspecialty extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  responsdoctorsMedicspecialtyState: this.props.responsdoctorsMedicspecialty,
                  selectedResponsdoctorsMedicspecialty: {
                        value: this.props.responsdoctorsMedicspecialty.responsdoctors_price_medic_responsdoctors_medicspecialty_id,
                        label: this.props.responsdoctorsMedicspecialty.responsdoctors_medicspecialty_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionResponsdoctorsMedicspecialty: [],
            }
      }
      componentDidMount() {
            this.getoptionResponsdoctorsMedicspecialty()
      }

      getoptionResponsdoctorsMedicspecialty = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].groupـofـdoctors_id,
                                          label: arr.data[k].groupـofـdoctors_name,
                                    })
                              }
                              self.setState({ optionResponsdoctorsMedicspecialty: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_groupـofـdoctors")
            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.send(fd)
      }
      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedResponsdoctorsMedicspecialty) => {
            var temparray = this.state.responsdoctorsMedicspecialtyState
            temparray.responsdoctors_price_medic_responsdoctors_medicspecialty_id = selectedResponsdoctorsMedicspecialty.value
            this.setState({
                  selectedResponsdoctorsMedicspecialty: selectedResponsdoctorsMedicspecialty,
                  responsdoctorsMedicspecialtyState: temparray,
            })
      }

      handleChangeMedicPrice = (event) => {
            var temparray = this.state.responsdoctorsMedicspecialtyState
            temparray.responsdoctors_price_medic_price = event
            this.setState({ responsdoctorsMedicspecialtyState: temparray })
      }

      handleChangeMedicResident = (event) => {
            var temparray = this.state.responsdoctorsMedicspecialtyState
            temparray.responsdoctors_price_medic_resident = event
            this.setState({ responsdoctorsMedicspecialtyState: temparray })
      }
      handleChangeMedicFellowship = (event) => {
            var temparray = this.state.responsdoctorsMedicspecialtyState
            temparray.responsdoctors_price_medic_fellowship = event
            this.setState({ responsdoctorsMedicspecialtyState: temparray })
      }

      handleChangeMedicAditionalcovarage = (event) => {
            var temparray = this.state.responsdoctorsMedicspecialtyState
            temparray.responsdoctors_price_medic_aditionalcovarage = event
            this.setState({ responsdoctorsMedicspecialtyState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { responsdoctorsMedicspecialtyState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_medic_tb")
            fd.append("responsdoctors_price_medic_id", responsdoctorsMedicspecialtyState.responsdoctors_price_medic_id)
            fd.append("responsdoctors_price_medic_price", responsdoctorsMedicspecialtyState.responsdoctors_price_medic_price)
            fd.append("responsdoctors_price_medic_resident", responsdoctorsMedicspecialtyState.responsdoctors_price_medic_resident)
            fd.append("responsdoctors_price_medic_fellowship", responsdoctorsMedicspecialtyState.responsdoctors_price_medic_fellowship)
            fd.append("responsdoctors_price_medic_aditionalcovarage", responsdoctorsMedicspecialtyState.responsdoctors_price_medic_aditionalcovarage)

            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { responsdoctorsMedicspecialtyState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_medic_tb")
            fd.append("responsdoctors_price_medic_id", responsdoctorsMedicspecialtyState.responsdoctors_price_medic_id)

            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {
                  optionResponsdoctorsMedicspecialty,
                  snackMode,
                  snackstr,
                  showSnack,
                  visible,
                  selectedResponsdoctorsMedicspecialty,
                  responsdoctorsMedicspecialtyState,
            } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={3}>
                                    <div>
                                          <label className="on">تخصص پزشک </label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"تخصص پزشک"}
                                                value={selectedResponsdoctorsMedicspecialty}
                                                onChange={this.handleInstalmentMode}
                                                options={optionResponsdoctorsMedicspecialty}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="قیمت پایه پزشک"
                                          handleInputt={this.handleChangeMedicPrice}
                                          value={responsdoctorsMedicspecialtyState.responsdoctors_price_medic_price}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="قیمت اضافی رزیدنت"
                                          handleInputt={this.handleChangeMedicResident}
                                          value={responsdoctorsMedicspecialtyState.responsdoctors_price_medic_resident}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                        type="percent"
                                        placeholder="درصد اضافی فلوشیپ"
                                        handleInputt={this.handleChangeMedicFellowship}
                                        value={responsdoctorsMedicspecialtyState.responsdoctors_price_medic_fellowship}
                                    />
                              </Grid>

                              <Grid item item xs={2}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="پوشش اضافی دیه"
                                          handleInputt={this.handleChangeMedicAditionalcovarage}
                                          value={responsdoctorsMedicspecialtyState.responsdoctors_price_medic_aditionalcovarage}
                                    />
                              </Grid>

                              <Grid item xs={1}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ResponsdoctorsMedicspecialty)
